import React from "react";
import { Box, Typography } from "@mui/material";
import { isProd } from "../../constants";

interface Props {
  children: JSX.Element | JSX.Element[];
  mini?: boolean;
}

export const PreProdOnlyWrapper = ({ children, mini }: Props): JSX.Element => {
  return !isProd ? (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        my: mini ? 0 : 4,
        background: "#eee",
      }}
    >
      {!mini && <Typography variant="body2">DEV ONLY: </Typography>}
      {children}
    </Box>
  ) : (
    <></>
  );
};
